import './emergencyStyle.css';

// Emergency

export const EMERGENCY_STATE = Object.freeze({
  NORMAL: 'NORMAL',
  NORMAL__EMERGENCY_REQUESTED: 'NORMAL__EMERGENCY_REQUESTED',
  EMERGENCY: 'EMERGENCY',
  EMERGENCY__COMMUNITY_CARE_REQUESTED: 'EMERGENCY__COMMUNITY_CARE_REQUESTED',
  COMMUNITY_CARE: 'COMMUNITY_CARE',
  COMMUNITY_CARE__EMERGENCY_REQUESTED: 'COMMUNITY_CARE__EMERGENCY_REQUESTED',
  UNFOLLOWED: 'UNFOLLOWED',
});

export function getEmergencyState(benhNhan) {
  // 1. UNFOLLOWED
  if (benhNhan.stopFollowTime) {
    return EMERGENCY_STATE.UNFOLLOWED;
  }
  // 2. COMMUNITY_CARE
  else if (benhNhan.communityCareTime) {
    if (benhNhan.requestEmergencyTime) {
      return EMERGENCY_STATE.COMMUNITY_CARE__EMERGENCY_REQUESTED;
    } else {
      return EMERGENCY_STATE.COMMUNITY_CARE;
    }
  }
  // 3. EMERGENCY
  else if (benhNhan.emergencyTime) {
    if (benhNhan.requestCommunityCareTime) {
      return EMERGENCY_STATE.EMERGENCY__COMMUNITY_CARE_REQUESTED;
    } else {
      return EMERGENCY_STATE.EMERGENCY;
    }
  }
  // 4. NORMAL
  else {
    if (benhNhan.requestEmergencyTime) {
      return EMERGENCY_STATE.NORMAL__EMERGENCY_REQUESTED;
    } else {
      return EMERGENCY_STATE.NORMAL;
    }
  }
}

// Swal

export const DEFAULT_SWAL_SUCCESS_OPTIONS = {
  title: 'Thành công',
  icon: 'success',
  toast: true,
  position: 'top-end',
  timer: 5000,
};

export const DEFAULT_SWAL_FAILURE_OPTIONS = {
  title: 'Thất bại',
  text: '',
  icon: 'error',
  toast: true,
  position: 'top-end',
  customClass: {content: 'emergency-alert-content'},
};

export function getErrorMessage(error) {
  return error instanceof Error
    ? (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    : '';
}
